<template>
   <div class="publicViewClass" style="padding-top:0">
        <div class="edit-step">
            <topicSteps :active = "1" :propList="propList"></topicSteps>
        </div>
             <div id="editPaper" class="app-inner">
        <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enTestPaper')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSteps('ruleForm')"
            >
             下一步
           </el-button>
            </div>
            <div class="edit-from">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
        <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
             <el-form-item label="试卷标题：" prop="paperName">
                    <el-input v-model="form.paperName" placeholder="请输入您的试卷标题【1-50】" clearable></el-input>
                </el-form-item>
                  <el-form-item label="试卷分类：" prop="classifyId">
                    <el-cascader
                :options="itemList"
                v-model="form.classifyId"
                 @change="classSelect1"
                separator="--"
                clearable
                ref="cascaderRef"
                 change-on-select
                >
            </el-cascader>
                 </el-form-item>
                       <el-form-item label="试卷封面：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">220*140</span></div>
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                 <el-form-item label="试卷描述：">
                    <el-input
                        type="textarea"
                        :rows="9"
                        placeholder="分享H5文案【1-50】"
                        minlength="1"
                        maxlength="50"
                        v-model="form.description"
                        clearable
                        >
                        </el-input>
                   </el-form-item>
                   <el-form-item label="排序：">
                    <el-input v-model="form.sort" placeholder="请输入排序【非必填】" clearable></el-input>
                </el-form-item>
                   <el-form-item label="试卷关联仿真应用：">
                     <el-select v-model="form.appList" multiple placeholder="请选择">
                        <el-option
                        v-for="(item,index) in myAppList"
                        :key="index"
                        :label="item.appName"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
        </el-form>
            </div>
             </div>
   </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import {listTree,editPapeItem,getPaper,getPaperFzList,getappGl} from "@/api/enterprise/index"  //试卷分类、新增修改试卷、获取试卷详情、获取关联仿真列表、我的应用
import debounce from '../../../utils/debounce.js' //防抖
export default {
    name:'addEnTestPaper',
    components: {
        topicSteps,
    },
    data() {
        return {
        myAppList:[],
        businessInfo:{},
        nextId:'',
        loading:false,
        selectList:[],
        centerDialogVisible:false,
        isShowId:false,
        relationList:[],
        oploadDialogVisible:false,
        uploadBoolean:false,
        itemList:[],
        form:{
        paperName:'',
        classifyId:'',
        logo:'',
        description:'',
        sort:'',
        appList:[]
        },
        rules:{
             paperName: [{ required: true, message: '请输入您的试卷标题', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
              classifyId: [{ required: true, message: '请选择试卷分类', trigger: 'change' }],
              logo:[{ required: true, message: '请上传试卷封面图', trigger: 'blur' }],
        },
        headers:{},  
        propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'添加试题',
            },{
                steps:3,
                text:'试卷设置',
            },{
                steps:4,
                text:'完成', 
            }

        ]
        }
    },
    created () {
         this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getPaperDetail()
        this.getthisType()
        this.getappAllList()
         let token = LocaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
         getappAllList(){
            getappGl({businessId:this.businessInfo.id},'enterprise').then(res => {
                this.myAppList = res.data
            })
        },
        // 获取关联仿真列表
        getrFzList(){
        getPaperFzList({id:this.$route.query.id})
        .then(res =>{
            if(res.code == 0){
                console.log(res)
                for (const key in res.data) {
                    this.form.appList.push(res.data[key].appId)
                }
            }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
            }
        })
        },
        // 获取试卷详情
        getPaperDetail(){
            getPaper({id:this.$route.query.id},'get')
            .then(res =>{
               this.form = {
                paperName:res.data.paperName,
                classifyId:res.data.classifyId,
                logo:res.data.logo,
                description:res.data.description,
                sort:res.data.sort,
                appList:[]
                }
                if(this.$route.query.id){
                     this.getrFzList()
                }
            })
            .catch(err =>{})
        },
         // 删除
        deletPro(data){
              let arr = []
            arr.push(data)
        let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.relationList = delet
        //   this.$refs.appTemplate.editfun(this.relationList) 
        },
          // 确认选择
        onSubmit1(){
            this.isShowId = true
           this.relationList = this.selectList
           this.centerDialogVisible = false
        },
          // 表格选择
        classSelect(val,val1){
           this.selectList = val
           this.isShowId = val1
        },
          // 取消选择
        reback1(){
            this.$refs.appTemplate.remove()  
            if(this.$route.query.id) this.isShowId = true
             this.centerDialogVisible = false  
        },
        // 关联仿真应用
        openBl(){
             this.centerDialogVisible = true  
            this.$nextTick(function () {   
                 this.$refs.appTemplate.editfun(this.relationList)    
             })
        },
        // 下一步
        openSteps(formName){
            let sumArr = []
            for (const key in this.form.appList) {
                sumArr.push(
                     {
                        appId:this.form.appList[key]
                    }
                )
            }
            let params = { 
                 paperName: this.form.paperName,
                    classifyId: this.form.classifyId,
                    logo: this.form.logo,
                    description: this.form.description,
                    sort: this.form.sort,
                    appList: sumArr,
                    businessId:this.businessInfo.id
            };
            let method = "post"
             if(!this.$route.query.id) params = {...params},method = "post";
            if(this.$route.query.id) params = {...params,id:this.$route.query.id}, method = "put";
              this.$refs[formName].validate((valid) => {  
                     if(valid){
                 //防抖提交
                    debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                        }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                    }) 
        },
               commentBness(params,method){
               this.loading = true
                editPapeItem(params,method,'enterprise')
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id) this.$message.success('新增成功'),this.nextId = res.data.id; 
                                setTimeout(() => {
                           this.$router.push({
                            name:'twoEnIndex',
                            query:{
                                twoId:this.$route.query.id || this.nextId
                            }
                           })
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
         // 图片放大
         oploadImgPre(){
            this.oploadDialogVisible = true
            },
        oploadImgDel(){
            this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
        },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
          classSelect1(value){
             if(value){
                let index = value.length-1
                this.form.classifyId = value[index]
            }
         },
        // 获取应用分类
           getthisType(){
            this.itemList = []
             listTree({
                name:'',
                businessId:this.businessInfo.id
             },'enterprise')
            .then(res => {
              if(res.data !==null){
                for (const key in res.data) {
                      this.itemList.push({
                    value:res.data[key].id,
                    label:res.data[key].name,
                    children:res.data[key].children ? [] : ''
                  }) 
                  if(res.data[key].children){
                    for (const i in res.data[key].children) {
                        this.itemList[key].children.push({
                            value:res.data[key].children[i].id,
                            label:res.data[key].children[i].name
                        })
                    }
                  } 
                }
              }else{
                    this.itemList = [] 
             }
             this.itemList = this.itemList.filter(item => item.value !=2);  
               
            })
            .catch(err => {
            })
        },
    }
}
</script>
<style lang="scss" scoped>
   .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
           ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>